import * as React from "react";
import { DiaryCompliance } from "webportalclient";
import { DiaryComplianceModal } from "./DiaryComplianceModal";
import { DiaryBaselinesModal } from "./DiaryBaselinesModal";

interface DiarySubjectSummaryPanelProps {
    subjectId: string;
    siteNumber: string;
    subjectNumber: string;
    numberOfDays: number;
    complianceRecords: DiaryCompliance[];
}

export const DiarySubjectSummaryPanel = ({ subjectId, siteNumber, subjectNumber, numberOfDays, complianceRecords }: DiarySubjectSummaryPanelProps) => {
    const [complianceModalVisible, setComplianceModalVisible] = React.useState(false);
    const [baselinesModalVisible, setBaselinesModalVisible] = React.useState(false);

    const ComplianceRow = () => {
        return (
            <td>
                <button className="btn btn-primary btn-outline" onClick={() => setComplianceModalVisible(true)}>View Compliance</button>
            </td>
        );
    }

    const BaselinesRow = () => {
        return (
            <td>
                <button className="btn btn-primary btn-outline" onClick={() => setBaselinesModalVisible(true)}>View Subject Baselines</button>
            </td>
        )
    }

    return (
        <>
            <div className="panel panel-default" data-automationid="DiarySubjectSummaryPanel">
                <div className="panel-body">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Site Number</th>
                                <th>Subject Number</th>
                                <th>Number of Days</th>
                                <th>Compliance</th>
                                <th>Baselines</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{siteNumber}</td>
                                <td>{subjectNumber}</td>
                                <td>{numberOfDays}</td>
                                {ComplianceRow()}
                                {BaselinesRow()}
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            {complianceModalVisible ? <DiaryComplianceModal records={complianceRecords} onClose={() => setComplianceModalVisible(false)} /> : null}
            {baselinesModalVisible ? <DiaryBaselinesModal subjectId={subjectId} onClose={() => setBaselinesModalVisible(false)} /> : null}
        </>
    );
}
